// Kontaktformular – Anbindung an den Mailrelay
// - konfigurationsgetrieben: die Form-ID kommt aus `data-form-id` (muss in forms.yaml stehen)
// - Honeypot-Feld `_hp` + Zeitfalle `_elapsed` als simpler Bot-Schutz
// - Status-Ausgabe erfolgt in `.form-status` innerhalb des Formulars
//
// Native Browser-Validierung bleibt aktiv: das submit-Event feuert erst,
// wenn alle `required`-Felder gültig sind.

// Mailrelay läuft auf Coolify unter eigener Subdomain. Aufruf cross-origin –
// der Service setzt die CORS-Header selbst, sofern der Origin in forms.yaml steht.
const ENDPOINT = 'https://contact-mailrelay.s1.fuelpipe.de/submit';

const MSG_SUCCESS = 'Vielen Dank! Deine Nachricht ist angekommen – ich melde mich zeitnah bei dir.';
const MSG_ERROR = 'Das hat leider nicht geklappt. Bitte versuche es später erneut oder schreib mir direkt an mail@equida.horse.';
const MSG_SENDING = 'Nachricht wird gesendet …';

type StatusKind = 'sending' | 'success' | 'error';

function setStatus(form: HTMLFormElement, kind: StatusKind, text: string): void {
	const status = form.querySelector<HTMLElement>('.form-status');
	if (!status) return;

	status.classList.remove('is-sending', 'is-success', 'is-error');
	status.classList.add(`is-${kind}`, 'is-visible');
	status.textContent = text;
}

export function initContactForm(form: HTMLFormElement): void {
	const loadedAt = Date.now(); // Start der Zeitfalle

	form.addEventListener('submit', async (e) => {
		e.preventDefault();

		const raw = Object.fromEntries(new FormData(form)) as Record<string, string>;

		// Leere optionale Felder gar nicht erst mitschicken: der Relay wertet
		// einen leeren String als fehlendes Feld und antwortet mit 400
		// ({"error":"missing_field"}). Weggelassen ist dagegen in Ordnung.
		const data: Record<string, string> = {};
		for (const [key, value] of Object.entries(raw)) {
			if (String(value).trim() !== '') data[key] = value;
		}

		data._hp = raw._hp ?? ''; // Honeypot immer mitschicken, auch leer
		data.formId = form.dataset.formId ?? '';
		data._elapsed = String(Date.now() - loadedAt); // Delta -> kein Uhren-Problem

		const btn = form.querySelector<HTMLButtonElement>('button[type="submit"]');
		if (btn) btn.disabled = true;
		setStatus(form, 'sending', MSG_SENDING);

		try {
			const res = await fetch(ENDPOINT, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(data),
			});
			if (!res.ok) throw new Error(`HTTP ${res.status}`);
			form.reset();
			setStatus(form, 'success', MSG_SUCCESS);
		} catch (err) {
			console.error('Versand fehlgeschlagen:', err);
			setStatus(form, 'error', MSG_ERROR);
		} finally {
			if (btn) btn.disabled = false;
		}
	});
}

// Initialisiert alle Formulare, die eine Form-ID mitbringen.
export function initContactForms(root: ParentNode = document): void {
	root.querySelectorAll<HTMLFormElement>('form[data-form-id]').forEach(initContactForm);
}
